module.exports = __webpack_public_path__ + "img/basf.5286ec16.jpg";